import { APP_TYPE } from "pages/Applications/AppDetails/constants";
import { trans } from "src/translations";
import { addQueryParamsToLocation, getQueryParamValue } from "utils/url";

import { FIELDS } from "./constants";

export const createTabPath = (tabId) => {
  return addQueryParamsToLocation(location, {
    tab: tabId,
  });
};

export const getActiveTabId = (appType) => {
  const tabId = getQueryParamValue(location, "tab");
  const defaultTab = appType === APP_TYPE.NATIVE ? "custom" : "generic";
  return tabId ? tabId : defaultTab;
};

const virtualKeys = [
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_PLACEHOLDER(),
    value: "",
    disabled: true,
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_LEFT(),
    value: "LEFT",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_RIGHT(),
    value: "RIGHT",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_UP(),
    value: "UP",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_DOWN(),
    value: "DOWN",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_ENTER(),
    value: "ENTER",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_BACK(),
    value: "BACK",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_BLUE(),
    value: "BLUE",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_RED(),
    value: "RED",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_GREEN(),
    value: "GREEN",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_YELLOW(),
    value: "YELLOW",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_MENU(),
    value: "MENU",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_0(),
    value: "0",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_1(),
    value: "1",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_2(),
    value: "2",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_3(),
    value: "3",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_4(),
    value: "4",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_5(),
    value: "5",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_6(),
    value: "6",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_7(),
    value: "7",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_8(),
    value: "8",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_9(),
    value: "9",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_PLAY(),
    value: "PLAY",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_PAUSE(),
    value: "PAUSE",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_PLAY_PAUSE(),
    value: "PLAY_PAUSE",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_STOP(),
    value: "STOP",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_TRACK_NEXT(),
    value: "TRACK_NEXT",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_TRACK_PREV(),
    value: "TRACK_PREV",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_FAST_FWD(),
    value: "FAST_FWD",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_REWIND(),
    value: "REWIND",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_SUBTITLE(),
    value: "SUBTITLE",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_AUDIO(),
    value: "AUDIO_TRACK",
  },
  {
    label: trans.APP_DETAILS_MANIFEST__FIELD_REMAPPING_KEY_INFO(),
    value: "INFO",
  },
];

export const getKeyValues = (name) =>
  virtualKeys.map(({ ...props }) => ({
    name,
    ...props,
  }));

const TABS_CONFIG = [
  {
    id: "generic",
    header: trans.APP_DETAILS_MANIFEST__GENERIC_HEADER,
    text: trans.APP_DETAILS_MANIFEST__GENERIC_TAB,
    fields: [
      FIELDS.type,
      FIELDS.app_label,
      FIELDS.app_icon,
      FIELDS.background_persistence,
      FIELDS.resolution,
      FIELDS.zoom,
      FIELDS.transparent,
      FIELDS.default_background_color,
      FIELDS.user_agent,
      FIELDS.allows_audio_only_playback,
      FIELDS.allow_scripts_to_close_windows,
      FIELDS.tts_controlled_by_platform,
    ],
  },
  {
    id: "navigation",
    header: trans.APP_DETAILS_MANIFEST__NAVIGATION_HEADER,
    text: trans.APP_DETAILS_MANIFEST__NAVIGATION_TAB,
    fields: [
      FIELDS.spatial_navigation_enabled,
      FIELDS.input_method,
      FIELDS.force_enable_virtual_keyboard,
      FIELDS.full_screen_virtual_keyboard,
      FIELDS.history_on_back,
      FIELDS.key_remapping,
    ],
  },
  {
    id: "security",
    header: trans.APP_DETAILS_MANIFEST__SECURITY_HEADER,
    text: trans.APP_DETAILS_MANIFEST__SECURITY_TAB,
    description: trans.APP_DETAILS_MANIFEST__SECURITY_DESCRIPTION,
    fields: [
      FIELDS.block_mixed_active_content,
      FIELDS.block_mixed_fetch_content,
      FIELDS.block_mixed_xhr_content,
      FIELDS.xhr_origin_check_enabled,
      FIELDS.no_cors_header_guard,
    ],
  },
  {
    id: "custom",
    header: trans.APP_DETAILS_MANIFEST__CUSTOM_HEADER,
    text: trans.APP_DETAILS_MANIFEST__CUSTOM_TAB,
    fields: [FIELDS.custom],
  },
  {
    id: "userscript",
    header: trans.APP_DETAILS_MANIFEST__SCRIPT_HEADER,
    text: trans.APP_DETAILS_MANIFEST__SCRIPT_TAB,
    description: trans.APP_DETAILS_MANIFEST__SCRIPT_DESCRIPTION,
    fields: [FIELDS.user_script],
  },
];

export const getTabsConfig = (appType) => {
  if (appType === APP_TYPE.NATIVE) {
    return TABS_CONFIG.filter((tab) => tab.id === "custom");
  }
  return TABS_CONFIG;
};
